import { cn } from '@tebuto/lib/utils'
import React from 'react'
import Mandatory from './Mandatory'

interface ILabel {
    htmlFor?: string
    children: React.ReactNode
    mandatory?: boolean
}

export function Label({
    htmlFor,
    children,
    mandatory = false,
    className = '',
    ...props
}: ILabel & React.HTMLProps<HTMLLabelElement>) {
    return (
        <label
            htmlFor={htmlFor}
            {...props}
            className={cn(
                'block text-xxs text-foreground-secondary font-medium mb-1 whitespace-pre-wrap max-w-full',
                className
            )}
        >
            {children}
            <Mandatory mandatory={mandatory} />
        </label>
    )
}
